import React from "react";
import { Link } from "~/i18n/navigation";
import { cn } from "~/lib/utils";

interface IconButtonProps {
  children: React.ReactNode;
  styleType?: "ghost";
  linkTo?: string;
  className?: string;
  onClick?: () => void;
  ariaLabel?: string;
}

const IconButton = ({
  children,
  styleType,
  linkTo,
  className,
  onClick,
  ariaLabel,
}: IconButtonProps) => {
  const baseStyles =
    "min-h-9 min-w-9 text-pory-pink-400 rounded-sm flex items-center justify-center";
  let typeStyles = "bg-pory-pink-400 hover:bg-pory-pink-500 text-white"; // default primary

  if (styleType === "ghost") {
    typeStyles =
      "border-2 border-pory-pink-400 text-pory-pink-400 bg-white hover:bg-pory-pink-500 hover:text-white";
  }

  // Adjust icon size and centering
  const iconWrapperStyles =
    "flex justify-center items-center w-full [&>svg]:w-6 [&>svg]:h-6";

  const combinedClassName = cn(baseStyles, typeStyles, className);

  if (linkTo) {
    return (
      <Link href={linkTo} className={combinedClassName} aria-label={ariaLabel}>
        <span className={iconWrapperStyles}>{children}</span>
      </Link>
    );
  }

  return (
    <button
      onClick={onClick}
      className={combinedClassName}
      aria-label={ariaLabel}
    >
      <span className={iconWrapperStyles}>{children}</span>
    </button>
  );
};

export default IconButton;
